import { render, staticRenderFns } from "./RefundRequests.vue?vue&type=template&id=2661b497"
import script from "./RefundRequests.vue?vue&type=script&lang=js"
export * from "./RefundRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports